import { images } from '.';
 
const memberFeatures = [  
    {   
        id: 1, 
        image: images.service1, 
        title: '會員設定',
        link: '/memberProfile',
        content: '要修改基本資料、車籍、支付方式等功能，請點選',
        paragraphs: [
            '',
            '',
        ],
        gallery: [ 
            images.service1Gallery1,
            images.service1Gallery2,
        ],
        benefits: {
            paragraphs: [
                ''
            ],
            list: [
                'Save You Time And Money',
                'Creates high aesthetic quality',
                'Maximize the space',
                'Adds a sense of functionality',
                'Increase the Value of your Home'
            ]
        },
        workFlow: {
            paragraphs: [
                ''
            ],
            workItems: {
                planning: '',
                design: '',
                construct: '',
            },
        },
        faqs: [
            // { 
            //     id: 1, 
            //     heading: 'How do we charge for projects?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // }, 
            // { 
            //     id: 2,
            //     heading: 'Do we offer free in-person estimates?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // },
            // {
            //     id: 3, 
            //     heading: 'What is our service area?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // },
            // {
            //     id: 4,
            //     heading: 'do we hire subcontractors?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // },
        ]
    },
    {   
        id: 2, 
        image: images.service1, 
        title: '停車紀錄',
        link: '/memberPlateRecords',
        content: '要修改基本資料、車籍、支付方式等功能，請點選',
        paragraphs: [
            '',
            '',
        ],
        gallery: [ 
            images.service1Gallery1,
            images.service1Gallery2,
        ],
        benefits: {
            paragraphs: [
                ''
            ],
            list: [
                'Save You Time And Money',
                'Creates high aesthetic quality',
                'Maximize the space',
                'Adds a sense of functionality',
                'Increase the Value of your Home'
            ]
        },
        workFlow: {
            paragraphs: [
                ''
            ],
            workItems: {
                planning: '',
                design: '',
                construct: '',
            },
        },
        faqs: [
            // { 
            //     id: 1, 
            //     heading: 'How do we charge for projects?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // }, 
            // { 
            //     id: 2,
            //     heading: 'Do we offer free in-person estimates?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // },
            // {
            //     id: 3, 
            //     heading: 'What is our service area?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // },
            // {
            //     id: 4,
            //     heading: 'do we hire subcontractors?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // },
        ]
    },
    {   
        id: 3, 
        image: images.service1, 
        title: '大全聯停車場查詢',
        link: '/lots',
        content: '要修改基本資料、車籍、支付方式等功能，請點選',
        paragraphs: [
            '',
            '',
        ],
        gallery: [ 
            images.service1Gallery1,
            images.service1Gallery2,
        ],
        benefits: {
            paragraphs: [
                ''
            ],
            list: [
                'Save You Time And Money',
                'Creates high aesthetic quality',
                'Maximize the space',
                'Adds a sense of functionality',
                'Increase the Value of your Home'
            ]
        },
        workFlow: {
            paragraphs: [
                ''
            ],
            workItems: {
                planning: '',
                design: '',
                construct: '',
            },
        },
        faqs: [
            // { 
            //     id: 1, 
            //     heading: 'How do we charge for projects?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // }, 
            // { 
            //     id: 2,
            //     heading: 'Do we offer free in-person estimates?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // },
            // {
            //     id: 3, 
            //     heading: 'What is our service area?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // },
            // {
            //     id: 4,
            //     heading: 'do we hire subcontractors?',
            //     content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            // },
        ]
    }
 
];

export default memberFeatures;